var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contents-passthrough"},[_c('div',{staticClass:"inner-trainer-container"},[_c('Timers'),(_vm.breakoutsEnabled)?_c('Breakouts'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }